'use client';

import { Root, Indicator } from '@radix-ui/react-checkbox';
import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithRef } from 'react';
import { Icon } from '@/shared/ui/icon';
import './amount-checkbox.scss';

const amountCheckboxVariants = cva('amount-checkbox', {
    variants: {
        size: {
            sm: 'amount-checkbox--sm',
            md: 'amount-checkbox--md',
        },
        checked: {
            true: 'amount-checkbox--checked',
            false: null,
        },
    },
    defaultVariants: {
        size: 'md',
    },
});

type Props = VariantProps<typeof amountCheckboxVariants> &
    ComponentPropsWithRef<typeof Root> & {
        disableCheck?: boolean;
        disableUncheck?: boolean;
    };
export const AmountCheckbox = ({
    className,
    checked,
    size = 'md',
    disableCheck = false,
    disableUncheck = false,
    onCheckedChange,
    ...props
}: Props) => {
    const handleCheckedChange = (newChecked: boolean) => {
        // Prevent checking if disableCheck is true
        if (newChecked && disableCheck) {
            return;
        }
        // Prevent unchecking if disableUncheck is true
        if (!newChecked && disableUncheck) {
            return;
        }
        onCheckedChange?.(newChecked);
    };
    return (
        <Root
            data-slot="amount-checkbox"
            className={amountCheckboxVariants({ size, checked: !!checked, className })}
            checked={checked}
            onCheckedChange={handleCheckedChange}
            disabled={(checked && disableUncheck) || (!checked && disableCheck)}
            {...props}
        >
            <Indicator
                forceMount
                data-slot="amount-checkbox-indicator"
                className="amount-checkbox__indicator"
            >
                {checked ? (
                    <Icon name="check" width={24} height={24} />
                ) : (
                    <Icon name="plus" width={24} height={24} className="amount-checkbox__plus-icon" />
                )}
            </Indicator>
        </Root>
    );
};
